module.exports = __webpack_public_path__ + "img/srpa_e.cf05d6b7.jpg";